/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import { Layout, SEO, Section, WYSIWYG } from "components"

const LegalDisclaimer = ({ pageContext }) => {
  return (
    <Layout pageContext={pageContext}>
      <SEO title="Legal Disclaimer | Okta" />
      <Section overrideStyles={{ minHeight: ["auto", "calc(100vh - 292px)"] }}>
        <h1 sx={{ mb: "25px" }}>Legal Disclaimer</h1>
        <WYSIWYG content={`<p>The information provided in <strong><a href="https://trust.okta.com/security-advisories/">Okta’s Security Advisories</a></strong> is provided "as is" without warranty of any kind. Okta disclaims all warranties, either express or implied, including the warranties of merchantability and fitness for a particular purpose. In no event shall Okta or its suppliers be liable for any damages whatsoever including direct, indirect, incidental, consequential, loss of business profits or special damages, even if Okta or its suppliers have been advised of the possibility of such damages. The foregoing exclusions will not apply to the extent prohibited by applicable law.</p>`}/>
      </Section>
    </Layout>
  )
}

export default LegalDisclaimer
